import { render, staticRenderFns } from "./universalSetting.vue?vue&type=template&id=6db5f2cd&scoped=true"
import script from "./universalSetting.vue?vue&type=script&lang=js"
export * from "./universalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5f2cd",
  null
  
)

export default component.exports